// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__nc4N1","select":"Header_select__3Z6dW","clinic":"Header_clinic__3iQ_E"};